import { Component, OnInit, Input, Output, EventEmitter, NgZone, HostListener, ViewChild, ElementRef } from '@angular/core';
import { JitCompilerFactory } from '@angular/platform-browser-dynamic';

@Component({
  selector: 'app-number-spin-button',
  templateUrl: './number-spin-button.component.html',
  styleUrls: ['./number-spin-button.component.css']
})
export class NumberSpinButtonComponent implements OnInit {

  @Input() levelValue: number;
  @Input() isDisabled = false;
  @Input() maxLength: number;

  @Output() levelValueChange = new EventEmitter<number>();
  @Output() buttonPressed = new EventEmitter<boolean>();
  @Output() saveValueEvent = new EventEmitter<number>();

  @ViewChild('inputNumberSpin') inputElement: ElementRef;

  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home'];

  private maxNumber: number;
  firstValue: number;
  constructor() { }

  @HostListener('keydown', ['$event'])
  @HostListener('paste', ['$event'])
  onKeyDown(event: KeyboardEvent | ClipboardEvent) {
    if (this.maxLength && event.type === 'keydown') {
      const evento = <KeyboardEvent>event;
      if (!this.isSpecialKey(evento.key)) {
        const value = this.inputElement.nativeElement.value + evento.key;
        if (value.length > this.maxLength) {
          this.levelValue = parseInt(value.substr(0, this.maxLength), 10);
          this.levelValueChange.emit(this.levelValue);
          this.inputElement.nativeElement.value = this.levelValue;
          event.preventDefault();
         }
       }
    }
  }
  private isSpecialKey(key: string): boolean {
    return this.specialKeys.some(specialKey => specialKey == key);
  }

  ngOnInit() {
    this.firstValue = this.levelValue;
    if (this.maxLength) {
      let value = '';
      for (let i = 0; i < this.maxLength; i++) {
        value += '9';
      }
      this.maxNumber = parseInt(value, 10);
     }
  }

  incrementModel() {
    if (this.levelValue + 1 <= this.maxNumber) {
      this.levelValue++;
      this.levelValueChange.emit(this.levelValue);
    }
  }

  decrementModel() {
    if (this.levelValue - 1 >= 0) {
      this.levelValue--;
      this.levelValueChange.emit(this.levelValue);
    }
  }

  modelChanged(event: string) {
    this.levelValue = !event || event == '' ? 0 : parseInt(event, 10);
    this.levelValueChange.emit(this.levelValue);
  }

  hasPressedComponent() {
    this.buttonPressed.emit(true);
  }

  resetValue() {
    this.levelValue = this.firstValue;
    this.levelValueChange.emit(this.levelValue);
   }

  saveValue() {
    this.firstValue = this.levelValue;
    this.levelValueChange.emit(this.levelValue);
    this.saveValueEvent.emit(this.levelValue);
   }
}
